import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class InventoryLocationXrefBus extends BaseBus
{
    constructor(data: InventoryLocationXrefBus) {
        super(data);
    }

    CID(): any {
        return this.inventoryLocationXrefid;
    }
    initialize(data: InventoryLocationXrefBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: InventoryLocationXrefBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }
        this.updateDt = new Date();
    }
    setId(id: any) {
        this.inventoryLocationXrefid = id;
    }

    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            this.updateUserId = userId;
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }
    inventoryLocationXrefid: string;
    inventoryId: string;
    inventoryLocationId: string;
    quantity: number;
    aisle: string;
    bin: string;
    dateAdded: Date;
    oldQuantity: number;
    section: string;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
    warehouse:string
    reason: string;
    onOrderQuantity: number;
    onTurnQuantity: number;
    isActive: boolean;
    isMerged: boolean;
    mergeQuantityChange: number;
    mergeDescription: string;
    maxThreshold: number;
    minThreshold: number;
   get canEdit(): boolean {
        let can: boolean = true;

        ////if ((this.hasId || (this.hasData && this.data.isAdded))) {
        //if (this.rights.MaintainQuotes) {
        //    can = true;
        //}
        ////}

        return can;
    }
}
